export default __webpack_public_path__ + "static/media/icon-coin-currency.7f9bffd2.svg";